module.exports = __webpack_public_path__ + "img/img17.38754968.svg";